import {apiSlice} from '../apiSlice';

const GROUP_URL = '/groups';

export const groupApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getGroups: builder.query({
            query: (token) => ({
                url: `${GROUP_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        getGroupById: builder.query({
            query: ({token, id}) => ({
                url: `${GROUP_URL}/${id}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            }),
        }),
        updateVehicleGroupById: builder.mutation({
            query: ({token, vehicleIds, id}) => ({
                url: `${GROUP_URL}/vehicle/update/${id}`,
                method: 'POST',
                body: {vehicleIds},
                headers: {
                    "x-access-token": token,
                    "Content-Type": "application/json"
                }
            })
        }),
        updateGroupById: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${GROUP_URL}/update/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    "x-access-token": token,
                }
            })
        }),
        deleteGroupById: builder.mutation({
            query: ({token, id}) => ({
                url: `${GROUP_URL}/delete/${id}`,
                method: 'DELETE',
                headers: {
                    "x-access-token": token,
                }
            })
        }),
        newGroup: builder.mutation({
            query: ({token, data}) => ({
                url: `${GROUP_URL}/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            }),
        }),
    }),
});

export const {
    useGetGroupsQuery,
    useDeleteGroupByIdMutation,
    useGetGroupByIdQuery,
    useUpdateVehicleGroupByIdMutation,
    useUpdateGroupByIdMutation,
    useNewGroupMutation,
} = groupApiSlice;
